export type { PaletteItemProps } from '../../types/palette-item';
export { PaletteItem } from './adapters/inbound/PaletteItem';
